const Getters = {
  getCustomerListFromState: (state) => {
    return state.customers
  },
  getCustomerIdNameListFromState: (state) => {
    return state.customerIdNameList
  }
}

export default Getters
